import NiceModal from '@ebay/nice-modal-react';
import { Grid, useMatches } from '@mantine/core';

import { useGetProphetPages } from '../../api/getPages';
import { AddButton } from '../AddButton';

import { AddModal } from './AddModal';
import { Page } from './Page';

import { Departments, Platforms } from '@/types';

type Props = {
  platform: Platforms;
  department: Departments;
};

export const Pages = ({ platform, department }: Props) => {
  const getProphetPages = useGetProphetPages({ department, platform });

  const columns = useMatches({
    base: 1,
    md: 2,
  });

  return (
    <>
      <Grid columns={columns}>
        {getProphetPages.data?.pages.map((page) => (
          <Grid.Col key={page._id} span={1}>
            <Page page={page} platform={platform} department={department} />
          </Grid.Col>
        ))}
      </Grid>
      <AddButton
        isLoading={getProphetPages.isLoading}
        onClick={() => NiceModal.show(AddModal, { platform, department })}
      />
    </>
  );
};
